import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, fmtMoney, fmtDate } from '../lib/api.js';

export default function Income() {
  const [list, setList] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get('/api/income').then(({ income }) => setList(income)).catch(e => setErr(e.message));
  }, []);

  if (err) return <div className="text-rust-700 text-sm">{err}</div>;
  if (!list) return <div className="text-ink-700/60 italic">Loading…</div>;

  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-serif text-olive-900">Income</h1>
        <Link to="/income/new" className="btn-primary">+ Log Sale</Link>
      </header>

      {list.length === 0 ? (
        <div className="card text-center py-10">
          <p className="text-ink-700/70">No income yet.</p>
          <Link to="/income/new" className="btn-primary mt-4">Log first sale</Link>
        </div>
      ) : (
        <ul className="space-y-2">
          {list.map(r => {
            const outstanding = r.total_cents - r.paid_cents;
            return (
              <li key={r.id} className="card">
                <div className="flex items-start gap-3">
                  <div className="flex-1">
                    <div className="font-medium text-ink-900">{r.customer_name || '(no name)'}</div>
                    <div className="text-sm text-ink-700/70">
                      {r.description} · {r.segment_name}
                    </div>
                    <div className="text-xs text-ink-700/60 mt-1">
                      {fmtDate(r.date)} · {r.payment_method || '—'} · by {r.submitted_by_name}
                      {outstanding > 0 && <span className="ml-2 pill bg-gold-500/15 text-gold-600">{fmtMoney(outstanding)} outstanding</span>}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-lg font-semibold text-olive-900">{fmtMoney(r.total_cents)}</div>
                    {outstanding > 0 && <div className="text-xs text-rust-700">{fmtMoney(r.paid_cents)} paid</div>}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
